import $http from '../../../../axios-instance';

/**
 * Cargar datos para imprimir etiquetas.
 * 
 * Permite ver la configuración final.
 * 
 * Frases H (sugeridas: clases de peligro|Indicaciones de peligro, Consejos de prudencia|Consejos de prudencia Generales )
 * Medidas
 * Pictogramas.
 *
 * @param Object { commit }
 * @param Object params -> { productId, versionId, languageId, companyId }
 * @return void
 */
export async function getProductSga({ commit }, params) {
    commit("dashboard/load", true, { root: true });
    commit('resetSga');        
    try {

        const { data: response } = await $http.get(`/products/sga2/config-labels/get-sga`, { params });
        if(!(response && typeof response === 'object' && 'data' in response && response.data && typeof response.data === 'object')) return
        
        commit('setSga', response.data);  
        
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}